/**
 * Vehicle damage severity values
 */
export enum VehicleDamageSeverityEnum {
	MINOR = 'minor',
	MODERATE = 'moderate',
	MAJOR = 'major',
}
